import Fuse from "fuse.js";

var fuseOpts = {
  shouldSort: true,
  includeScore: true,
  // tokenize: true,
  // matchAllTokens: true,
  threshold: 0.3,
  keys: ["key"],
};

export function fuzzySearch(query, pages) {
  if (!pages) return [];

  const fuse = new Fuse(pages, fuseOpts);
  const res = fuse.search((query && query.trim()) || "");
  return res;
}
